import { IAuthenticationProvider } from "../../backend/interfaces/IAuthenticationProvider";
import { GraphBaseUrlFromAuthEnvironment } from "../../backend/ms-graph/GraphClientInitOptions";
import { IsAuthPopupRequiredError, AuthError, AuthErrors } from "../../backend/office-js/auth/AuthErrors";
import { ErrorStringFromException } from "../../utils/utils"

/**
 * Auth can fail. Users especially hate it when it fails much after all the transcribing is done, when it fails just before the upload.
 * In the cases where auth fails due to requiring an interaction with the user, we want to present the user with a dialog upfront
 * asking them to sign-in. This at least gets rid of the work-aroundable auth errors.
 * @param authProvider The auth provider to perform the token check for
 * @param showAuthPopupCallback The callback that would invoke the AuthPopup dialog
 */
export async function PerformGetAccessTokenCheckAndShowAuthPopupIfNeeded(authProvider: IAuthenticationProvider, showAuthPopupCallback: (showPopup: boolean) => void): Promise<boolean> {
    try {
      await authProvider.GetAccessToken(GraphBaseUrlFromAuthEnvironment(authProvider.GetAuthEnvironment()));
      return true;
    } catch (error) {
      if (IsAuthPopupRequiredError(error)) {
        showAuthPopupCallback(true /*showAuthPopup*/);
        return false;
      }

      throw new AuthError(AuthErrors.InitialAuthFailed, ErrorStringFromException(error));
    }
  }
